import _ from 'lodash';
import axios from 'axios';
import csrfToken from '../../../shared/meta';
import axiosConfig from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axiosConfig });

const formDataHeaders = {
  'X-CSRF-TOKEN': csrfToken(),
  'content-type': 'multipart/form-data',
};

const headers = {
  'X-CSRF-TOKEN': csrfToken(),
};

const base = '/api/v1/lwadmin/announcement';

export function useGetAnnouncements() {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${base}s`,
    method: 'GET',
  }, { manual: true });
}

const buildFormData = payload => {
  const data = new FormData();

  _.forOwn(payload, (value, key) => {
    if (key === 'hero_image') {
      !!value && data.append(key, value);
    } else if (key === 'companies' || key === 'investor_types') {
      if (_.isEmpty(value)) {
        data.append(`${key}[]`, '');
      } else {
        _.each(value, v => data.append(`${key}[]`, v));
      }
    } else {
      data.append(key, value);
    }
  });

  return data;
};

export function createAnnouncement(payload) {
  return axios.post(base, buildFormData(payload), { headers: formDataHeaders });
}

export function updateAnnouncement(id, payload) {
  return axios.put(`${base}/${id}`, buildFormData(payload), { headers: formDataHeaders });
}

export function publishAnnouncement(id) {
  return axios.put(`${base}/${id}/publish`, { headers });
}

export function unpublishAnnouncement(id) {
  return axios.put(`${base}/${id}/unpublish`, { headers });
}
